export default {
	styleOverrides: {
		root: ({ ownerState, theme }) => ({
			...(ownerState.variant === 'permanent' && {
				'& .MuiDrawer-paper': {
					width: '100%',
					boxSizing: 'border-box',
					borderRight: 0,
					[theme.breakpoints.up('md')]: { width: 360 },
				},
			}),
		}),
	},
};
